// features/videos/useWatchRail.ts — where a watch page puts Up Next (2026-09-26), after the
// owner's concept (docs/References/Images/video_watch_page.webp):
//
//   desktop          → 'shell':  Up Next in the shell's right column, so the player, details
//                      and comments get the whole center column (the right column used to
//                      sit empty beside a narrower player).
//   desktop theater  → 'beside': the page borrows the right column too (useWideCenter); the
//                      player spans both, Up Next sits beside the details and comments.
//   below desktop    → 'below':  there is no right column; Up Next stacks under the details.
//
// The caller renders the rail itself for 'beside' and 'below' (see watchGrid.ts).
import type { ReactNode } from 'react';
import { useRightRail, useWideCenter } from '@/app/shell/RightRail';
import { useViewport } from '@/hooks';

export type WatchRailPlace = 'shell' | 'beside' | 'below';

/** Publishes `rail` to the shell when it belongs there. Pass a STABLE (memoized) node. */
export function useWatchRail(rail: ReactNode, theater: boolean): WatchRailPlace {
  const isDesktop = useViewport() === 'desktop';
  const place: WatchRailPlace = !isDesktop ? 'below' : theater ? 'beside' : 'shell';
  useRightRail(place === 'shell' ? rail : null);
  useWideCenter(place === 'beside');
  return place;
}
